const isDev = process.env.NODE_ENV === 'development';
const localhost = 'http://localhost:8080';
const productionUrl = 'https://pro.motorway.co.uk';

module.exports = {
	APP_REQUEST_HEADER: process.env.APP_FULL_NAME || 'dealer-web-app',
	DEALER_WEBAPP_URL: isDev ? localhost : process.env.DEALER_WEBAPP_URL || productionUrl,
	PROVIDERS_VERSIONS_HEADER: process.env.PROVIDERS_VERSIONS,
};
